module.exports = __webpack_public_path__ + "static/media/open-ai.dc2f6b1e.svg";